import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { TranslateService } from '@ngx-translate/core';
import { GameRecord, NetworkConstants, deepCopy,removeUndefined  } from 'diwimamodelweb/lib';
import { diffObject } from 'diwimamodelweb/lib/utils/obejct-diff';
import { BehaviorSubject, Subject, Subscription, combineLatest } from 'rxjs';
import { skipWhile, take, takeUntil, map } from 'rxjs/operators';
import { SettingsService } from './settings.service';
import { TransactionLogService } from './transaction-log.service';
import { UserService } from './user.service';
import { environment } from 'src/environments/environment';
import JSZip from 'jszip';
import { XMLParser } from "fast-xml-parser";
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { UserFeedbackService } from './user-feedback.service';
import { isFirebaseGeoPoint } from 'diwimamodelweb/src';
import { Firestore, collection, deleteDoc, doc, setDoc, updateDoc, query, collectionData, where, getDocs, GeoPoint, or } from '@angular/fire/firestore';
import { getStorage, ref, listAll, deleteObject, getDownloadURL } from "@angular/fire/storage";
import { updatesToFirestoreUpdates } from './utils/utils';
import { applySharingFieldDeletes } from './context-rights-picker/sharing-fields';

@Injectable({
  providedIn: 'root'
})

export class GamerecordService {
  private Ifirestore = inject(Firestore);
  storage = getStorage();

  ngUnsubscribe: Subject<void> = new Subject<void>();
  subscriptions: Map<string, Subscription> = new Map([])

  // subAllGameRecords: Subscription
  gameRecordAttatchmentsSubject$ = new BehaviorSubject<any[]|undefined>([])
  gameRecordpictureURLlinksDocSubject$ = new BehaviorSubject<any|undefined>({})
  allGameRecordsSubject$ = new BehaviorSubject<GameRecord[]|undefined>(undefined)
  printTemplatesGameRecordsSubject$ = new BehaviorSubject<any[]|undefined>(undefined)
  selectedTemplateGameOriginSubject$ = new BehaviorSubject<any|undefined>(undefined)
  subbedContext: string|undefined = undefined
  
  constructor(
    private userService: UserService,
    private transactionLogService: TransactionLogService,
    private firestore: AngularFirestore,
    private settingsService: SettingsService,
    private translate: TranslateService,
    private functions: AngularFireFunctions,
    private userFeedbackService: UserFeedbackService
    // private astorage: AngularFireStorage
  ) {
    // this.settingsService.selectedUserContext$.pipe(
    //   // skipWhile(el => !el),
    //   // map(el => el.identifier)
    // ).subscribe((context) => {
    //   if (!context) {
    //     this.subbedContext = undefined
    //     return 
    //   }
    //   if (this.subbedContext?.identifier == context.identifier) return 
    //   this.allGameRecordsSubject$.next(undefined)
    //   if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    //   this.subscriptions.set('1',
    //     this.observeAllGamerecordsContext(context)
    //   )
    //   this.subbedContext = context
    // })
  }

  observeData(dataFromIds) {
    const contextId = this.settingsService.selectedUserContext$.value?.identifier

    // console.log('-- observeData GR --', this.subbedContext)
    if (this.subbedContext == dataFromIds) return 
    if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    if (!!this.allGameRecordsSubject$.value) this.allGameRecordsSubject$.next(undefined)
    const superOrsubContext = this.settingsService.superContext.value || this.settingsService.subContext.value
    if (superOrsubContext) {
      const context = this.settingsService.selectedUserContext$.value
      const subIds = this.settingsService.getSubcontextIds()
      const sub = this.observeAllGamerecordsContextAndContextIds(contextId, subIds, context)
      this.subscriptions.set('1', sub)
    } else {
      const sub = this.observeAllGamerecordsContext(contextId)
      this.subscriptions.set('1', sub)
    }
    this.subbedContext = superOrsubContext ? dataFromIds : contextId
  }

  async removeSubs(): Promise<void> {
    this.ngUnsubscribe.next()
    this.subbedContext = undefined
    this.subscriptions.forEach((value) => {
      value.unsubscribe()
    })
    // reset loaded data
    this.allGameRecordsSubject$.next(undefined)
    return Promise.resolve()
  }

  updateGameRecord(oldGameRecord: GameRecord, newGameRecord: GameRecord): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldGameRecord, newGameRecord, {})
      const map = updatesToFirestoreUpdates(updates)
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const key = Object.entries(map)

        key.forEach( (entry, index) => {
          const key = entry[0]
          const value = entry[1]
          if(isFirebaseGeoPoint(value)){
            let newLoc = value as GeoPoint
            map[key] = new GeoPoint(newLoc.latitude, newLoc.longitude)
            if(updates[key]){
              if(updates[key].oldValue)
              updates[key].oldValue = new GeoPoint(updates[key].oldValue.latitude, updates[key].oldValue.longitude)
              if(updates[key].newValue)
              updates[key].newValue = new GeoPoint(newLoc.latitude, newLoc.longitude)
            }
          }
        })
        const list = await this.transactionLogService.determineDiff(user, updates, newGameRecord.identifier, NetworkConstants.COLLECTION_GAMERECORD)
        map['updateTimestamp'] = new Date()
        applySharingFieldDeletes(map, oldGameRecord as any, newGameRecord as any)
        // await this.firestore.collection(NetworkConstants.COLLECTION_GAMERECORD).doc(newGameRecord.identifier).update(map)
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_GAMERECORD, newGameRecord.identifier)
        await updateDoc( docRef, map)
        // if successfull save transactionlog..
        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })

    // this.transactionlogService.determineDiff()
  }

  observeAllGamerecordsContext(contextId: string) {
    // return this.firestore.collection(NetworkConstants.COLLECTION_GAMERECORD, ref => ref.where('contextId', '==', contextId)).valueChanges()
      const path = `${NetworkConstants.COLLECTION_GAMERECORD}`
      const collRef = collection(this.Ifirestore, path);
      const q = query(collRef, where('contextId', '==', contextId));

      return collectionData(q)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (elements: any[]) => {
        let listGR: GameRecord[] = []
        const context = await this.settingsService.selectedUserContext$.pipe(
          skipWhile(el => !el),
          take(1)
        ).toPromise()
        elements.forEach((el) => {
          const gr = new GameRecord(context)
          gr.setFromAny(el)
          listGR.push(gr)
        })
        this.allGameRecordsSubject$.next(listGR)
      })
  }

  observeAllGamerecordsContextAndContextIds(contextId: string, contextIds: string[], context) {
    // console.log('--- observeAllGamerecordsContextAndContextIds ---', contextId, contextIds)
    
    const collRef = collection(this.Ifirestore, NetworkConstants.COLLECTION_GAMERECORD);
    const CHUNK_SIZE = 30;
    const qy$ = [];

    qy$.push(collectionData(query(collRef, where('contextId', '==', contextId))));
    qy$.push(collectionData(query(collRef, where('contextIds', 'array-contains', contextId))));

    if (contextIds?.length) {
      for (let i = 0; i < contextIds.length; i += CHUNK_SIZE) {
        const chunk = contextIds.slice(i, i + CHUNK_SIZE);
        qy$.push(collectionData(query(collRef, where('contextId', 'in', chunk))));
      }
    }

    return combineLatest(...qy$)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (results: any[][]) => {
          const byId = new Map<string, GameRecord>();
          results.flat().forEach((el: any) => {
            const gr = new GameRecord(context);
            gr.setFromAny(el);
            const id = (gr as any)?.identifier ?? el?.identifier;
            if (id) byId.set(id, gr);
          });
          this.allGameRecordsSubject$.next([...byId.values()]);
        },
        error: (err) => console.error('Firestore error:', err),
      });
  }

// -______________
  async loadGameRecordPictureURLlinks(gameRecordId){
    return new Promise((resolve, reject) => {
      // this.firestore.collection(NetworkConstants.COLLECTION_GAMERECORD).doc(gameRecordId).collection("Image").get().pipe().subscribe( results => {})
      const path = `${NetworkConstants.COLLECTION_GAMERECORD}/${gameRecordId}/Image`
      const docsRef = collection(this.Ifirestore, path)

      getDocs(docsRef)
      .then(results => {
        if (!results.empty) {
          const imagesToAdd = results.docs.map( (doc, index) => {
            const data = doc.data()
            const identifier = data?.identifier
            const id = doc.id
            data.id = id
            let nurl, preview

            const preview_img = identifier.match(/preview_(.+).jpg/)

            if(preview_img && preview_img[1]){
              nurl= new URL(`${environment.apiURL}/gameRecord/${gameRecordId}/images/${id}.jpeg`)
              preview = new URL(`${environment.apiURL}/gameRecord/${gameRecordId}/images/${id}.jpeg`)
            }else{
              nurl = new URL(`${environment.apiURL}/gameRecord/${gameRecordId}/images/${identifier}.jpeg`)
              preview = new URL(`${environment.apiURL}/gameRecord/${gameRecordId}/images/${identifier}.jpeg`)
            }
            return nurl.href        
          })
          resolve(imagesToAdd)
        }else{
          reject()
        }
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
    })

  }
  loadGameRecordImg = async (gameRecordId: string): Promise<any[]> => {
    var links=[]

    // const grr = await this.firestore.collection(NetworkConstants.COLLECTION_GAMERECORD).doc(gameRecordId).collection("Image").get().toPromise()
    const path = `${NetworkConstants.COLLECTION_GAMERECORD}/${gameRecordId}/Image`
    const colRef = collection(this.Ifirestore, path)

    const grr = await getDocs(colRef)
   const imagesData = grr.docs.map((dataItem) => {
      const data = dataItem.data()
      let identifier = data?.identifier
      const id = dataItem.id
      let nurl 
      let preview
      data.id = id

      const preview_img = data.identifier.match(/preview_(.+).jpg/)
      if(preview_img && preview_img[1]){
        nurl= new URL(`${environment.apiURL}/gameRecord/${gameRecordId}/images/${id}.jpeg`)
        preview = new URL(`${environment.apiURL}/gameRecord/${gameRecordId}/images/${id}.jpeg`)
      }else{
        nurl = new URL(`${environment.apiURL}/gameRecord/${gameRecordId}/images/${identifier}.jpeg`)
        preview = new URL(`${environment.apiURL}/gameRecord/${gameRecordId}/images/${identifier}.jpeg`)
      }
  
      const a = {
        attribute: "pictureURLlinks" + links.length,
        resourceId: nurl.href,
        preview: preview.href ? preview.href : nurl.href,
        fileName:id
      }
      if(!links.includes(nurl.href)){
        links.push(a) 
      }
      return data
    });
    const allImagesData = this.gameRecordpictureURLlinksDocSubject$.value
    allImagesData[gameRecordId]= imagesData
    this.gameRecordpictureURLlinksDocSubject$.next(allImagesData)
    return links
  }

  getAttachmentsFilesGameRecord(gameRecordId){
    this.userFeedbackService.loading.emit(true)
    var attachments=[]
    const routeFolder = `gameRecord/${gameRecordId}/attachments`

    const listRef = ref(this.storage, routeFolder);

    // Find all the prefixes and items.
    listAll(listRef)
    .then((res) => {
      res.prefixes.forEach((folderRef) => { });

      let all = [] //  this.gameRecordAttatchmentsSubject$.value ??
      res.items.forEach(async (itemRef, index) => {
        this.userFeedbackService.loading.emit(true)

        await getDownloadURL(ref(this.storage, itemRef.fullPath))
        .then((url) => {
          all.push({gameRecordId:gameRecordId,name:itemRef.name, reference:itemRef.fullPath, url: url})
          attachments.push({gameRecordId:gameRecordId,name:itemRef.name, reference:itemRef.fullPath, url: url})
          this.gameRecordAttatchmentsSubject$.next(all)
        })
        .catch((error) => {// Handle errors
          this.userFeedbackService.loading.emit(false)
        });

        if (index === res.items?.length - 1) {
          this.userFeedbackService.loading.emit(false)
        }
      });
      if(res.items?.length==0)
      this.userFeedbackService.loading.emit(false)

    }).catch((error) => {
      this.userFeedbackService.loading.emit(false)
    });
    return attachments
  }

  //---------------------------------------

  createGameRecord(newGameRecord: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const docRef = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_GAMERECORD))
      const now = new Date()
      newGameRecord['identifier'] = docRef.id
      newGameRecord['creationDate'] = now
      newGameRecord['updateTimestamp'] = now
      try {
        const contextId = this.settingsService.selectedUserContext$.value.identifier
        if (!contextId) reject("No context id")
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const logItems = this.transactionLogService.createLog(user, newGameRecord.identifier, NetworkConstants.COLLECTION_GAMERECORD, newGameRecord)
        newGameRecord['contextId'] = contextId
        await setDoc(docRef,{...newGameRecord} )
        await this.transactionLogService.saveTransactionLog(logItems)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }


  deleteGameRecord(gameRecord: GameRecord): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const gToDelete = deepCopy(gameRecord, gameRecord.replacerFn)
        const dataToDelete = removeUndefined(gToDelete)
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const transactionLogItem = this.transactionLogService.deleteDocumentLog(
          user,
          gameRecord.identifier,
          NetworkConstants.COLLECTION_GAMERECORD,
          dataToDelete
        )
        const promiseArray = []
        promiseArray.push(
          this.transactionLogService.saveTransactionLog([transactionLogItem])
        )
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_GAMERECORD, gameRecord.identifier)
        // const delOperation = this.firestore.collection(NetworkConstants.COLLECTION_GAMERECORD).doc(gameRecord.identifier).delete()
        const delOperation = await deleteDoc( docRef)
        promiseArray.push(delOperation)
        resolve()
      } catch (error) {
        reject(error)        
      } 
    })
  }

  //---------------------------------------

  getPrintTemplatesGameRecord(){
    var attachments=[]
    var attachmentsFileInfo = {}
    if(this.printTemplatesGameRecordsSubject$.value)
      attachments = this.printTemplatesGameRecordsSubject$.value

    const routeFolder = `PrintTemplates/all`
    const listRef = ref(this.storage, routeFolder);

    listAll(listRef)
    .then((res) => {
      res.prefixes.forEach((folderRef) => {});

      res.items.forEach(async (itemRef) => {
        await getDownloadURL(ref(this.storage, itemRef.fullPath)).then(async (url) => {
          try {
            const fileBASE = await this.getFileFromUrl(url, itemRef.name, 'application/zip')
            if(fileBASE){
              const nameFile = itemRef.name.split('.zip')
              const name = nameFile[0]
              attachmentsFileInfo[itemRef.name] = {reference:itemRef.fullPath, url: url, item: itemRef,file:fileBASE}
              attachments.push({fileNameExtension:itemRef.name, name:name, reference:itemRef.fullPath, url: url, item: itemRef, file:fileBASE})
              this.printTemplatesGameRecordsSubject$.next(attachments)
            }
          } catch (err) {
            console.error(err.name, err.message);
          }
        }).catch((error) => {});
      });
    }).catch((error) => { });
    return attachments
  }


  async getFileFromUrl(url, name, defaultType){
    const response = await fetch(url);
    const data = await response.blob();
    if(data?.type == 'application/zip'){
      return new File([data], name, {
        type: data.type || defaultType,
      });
    }else{
      return false
    }


  }
  async unzipFile(file, name?){
    // var attachments = 
    var reader = new FileReader();
    let jsonData
      
      reader.readAsDataURL(file);
      await JSZip.loadAsync(file).then((zip) => {
        const allfiles = Object.keys(zip.files)
        if(allfiles.includes('form.json')){
          zip.files['form.json'].async('string').then((fileData) => { // template.json for passDefinition data
            jsonData = JSON.parse(fileData)
            this.selectedTemplateGameOriginSubject$.next({type:'json', data:jsonData})
            // return fileData
          });
        }

        if(allfiles.includes('form.plist')){
          zip.files['form.plist'].async('string').then((fileData) => { // template.json for passDefinition data
            const parser2 = new XMLParser();
            let jObj = parser2.parse(fileData);
            this.selectedTemplateGameOriginSubject$.next({type:'xml', data:jObj})
            
          });
        }

        
      })

      return jsonData
  }

  async addCreateGameOriginForm(data){
    this.userFeedbackService.loading.emit(true)

    const callable = this.functions.httpsCallable('tasks-createGameOriginReport')
    const reply: any = await callable(data).toPromise().then(value => {
      this.userFeedbackService.loading.emit(false)
      setTimeout(() => {
      this.getAttachmentsFilesGameRecord(data.gameRecordId)
      }, 2000);
    })

  }


  async deleteFile(fileName: string, gameRecordId): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
    const filePath = `gameRecord/${gameRecordId}/images/${fileName}`
    const storageRef = ref(this.storage, filePath);
    try {
       deleteObject(storageRef).then( value => {
        resolve(true)
      });
    } catch (error) {
      reject(false)
      console.error('Error deleting image', error);
      throw error;
    }

    })
  }

  async deleteFilesStorage(fileNames: string[], gameRecordId, imageToDelete): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {

      const deletePromises = fileNames.map((fileName) => {
        const filePath = `gameRecord/${gameRecordId}/images/${fileName}`
        const fileRef = ref(this.storage, filePath);
        return deleteObject(fileRef);
      });

      try {
        await Promise.all(deletePromises);
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const dataToDelete = removeUndefined(imageToDelete)
        const transactionLogItem = this.transactionLogService.deleteDocumentLog(
          user,
          `${NetworkConstants.COLLECTION_GAMERECORD}/${gameRecordId}/Image/${imageToDelete.id}`,
          NetworkConstants.COLLECTION_GAMERECORD,
          dataToDelete
        )
        const promiseArray = []
        promiseArray.push(
          this.transactionLogService.saveTransactionLog([transactionLogItem])
        )
        const docRef = doc(this.Ifirestore, `${NetworkConstants.COLLECTION_GAMERECORD}/${gameRecordId}/Image/${imageToDelete.id}`)
        if(docRef){
           const delOperation = await deleteDoc( docRef)
            promiseArray.push(delOperation)
        }
       
        resolve(true)
        console.log('All files deleted successfully');
      } catch (error) {
        resolve(false)
        console.error('Error deleting one or more files:', error);
      }
    })

  }

}
